import React from 'react';
import {connect} from 'react-redux';
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

import Game from './Game';
import { gameActions } from '../../actions';
import {getOrderedGames} from '../../selectors';

let prev  = 0;
let last  = 0;
class GameList extends React.Component {
    constructor(){
        super();
         this.state = {
           currentPage: 1,
           gamesPerPage: 6,
         }
    }

    componentDidMount(){
        this.props.fetchGames();
    }

    handleClick = (event) => {
        event.preventDefault();
        this.setState({
          currentPage: Number(event.target.id)
        });
    }

    handleLastClick = (event) => {
        event.preventDefault();
        this.setState({
          currentPage:last
        });
    }

    handleFirstClick = (event) => {
        event.preventDefault();
        this.setState({
          currentPage:1
        });
    }

    render(){
        let { currentPage, gamesPerPage } = this.state;

        // Logic for displaying current games
        let indexOfLastGame = currentPage * gamesPerPage;
        let indexOfFirstGame = indexOfLastGame - gamesPerPage;
        let currentGames = this.props.games.slice(indexOfFirstGame, indexOfLastGame);
        prev  = currentPage > 0 ? (currentPage -1) :0;
        last = Math.ceil(this.props.games.length/gamesPerPage);

        // Logic for displaying page numbers
        let pageNumbers = [];
        for (let i = 1; i <=last; i++) {
            pageNumbers.push(i);
        }

        return(
            <div className="container">
                <div className="row gamesList">
                    {
                        currentGames.map((game,index) =>{
                            return <Game key={index} game={game} />;
                        })
                    }
                </div>
                <nav>
                    <Pagination>
                        <PaginationItem>
                            { prev === 0 ? <PaginationLink disabled>First</PaginationLink> :
                                <PaginationLink onClick={this.handleFirstClick} id={prev} href={prev}>First</PaginationLink>
                            }
                        </PaginationItem>
                        <PaginationItem>
                            { prev === 0 ? <PaginationLink disabled>Prev</PaginationLink> :
                                <PaginationLink onClick={this.handleClick} id={prev} href={prev}>Prev</PaginationLink>
                            }
                        </PaginationItem>
                        {
                            pageNumbers.map((number,i) =>
                                    <PaginationItem key={i} active = {pageNumbers[currentPage-1] === (number) ? true : false} >
                                        <PaginationLink onClick={this.handleClick} href={number} key={number} id={number}>
                                            {number}
                                        </PaginationLink>
                                    </PaginationItem>
                            )
                        }
                        <PaginationItem>
                            {
                            currentPage === last ? <PaginationLink disabled>Next</PaginationLink> :
                            <PaginationLink onClick={this.handleClick} id={pageNumbers[currentPage]} href={pageNumbers[currentPage]}>Next</PaginationLink>
                            }
                        </PaginationItem>
                        <PaginationItem>
                            {
                            currentPage === last ? <PaginationLink disabled>Last</PaginationLink> :
                            <PaginationLink onClick={this.handleLastClick} id={pageNumbers[currentPage]} href={pageNumbers[currentPage]}>Last</PaginationLink>
                            }
                        </PaginationItem>
                    </Pagination>
                </nav>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        games: getOrderedGames(state)
    }
}
export default connect(mapStateToProps, gameActions)(GameList);


// WEBPACK FOOTER //
// ./src/components/Games/GameList.js